﻿import * as ScreenLockservice from "../core/services/screenLockService/screenLock.service";

export class ShellController {
    public static $inject = ['screenLockService', '$timeout'];

    //lock screen must show for the minimum duration below
    //this stops the locks screen from flashing for sub-second async calls
    public minimumScreenLockDuration: number = 800;
    public isScreenLocked: boolean = false;
    private screenLockStartTime: Date;

    public constructor(
        public screenLockService: ScreenLockservice.ScreenLockService,
        public $timeout: ng.ITimeoutService
    ) {
        this.activate();
    }

    public activate() {
        this.screenLockService.listen(this.lockScreenEventHandler);
        // if we've missed a previous broadcast by the time we get to this point (race condition), go ahead and lock the screen
        if (this.screenLockService.currentState === 1) {
            this.lockScreen(1);
        }
    }

    //again lexical scope keeps (this.) to the scope of the class
    private lockScreenEventHandler = (event, args) => {

        if (typeof args.state !== "undefined") {

            this.lockScreen(args.state);
        }
    }

    private lockScreen(isScreenLocked: number) {

        if (isScreenLocked === 0) {

            if (typeof this.screenLockStartTime !== "undefined") {

                const lockDuration = new Date().getTime() - this.screenLockStartTime.getTime();

                if (lockDuration > this.minimumScreenLockDuration) {
                    this.isScreenLocked = false;
                } else {
                    this.$timeout(() => { this.isScreenLocked = false; }, this.minimumScreenLockDuration - lockDuration);
                }
            }

        }

        if (isScreenLocked === 1) {

            this.isScreenLocked = true;
            this.screenLockStartTime = new Date();
        }

    }
}